/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrPrimaryKeyValue } from './igr-primary-key-value';
import { PrimaryKeyValue } from './PrimaryKeyValue';
import { TypeRegistrar } from "igniteui-react-core";
var IgrPrimaryKeyValueModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrPrimaryKeyValueModule() {
    }
    IgrPrimaryKeyValueModule.register = function () {
        TypeRegistrar.registerCons("IgrPrimaryKeyValue", IgrPrimaryKeyValue);
        TypeRegistrar.register("PrimaryKeyValue", PrimaryKeyValue.$type);
    };
    return IgrPrimaryKeyValueModule;
}());
export { IgrPrimaryKeyValueModule };
//# sourceMappingURL=igr-primary-key-value-module.js.map
